const rules = {
  "mail_class_rules": {
    "First-Class Mail": [
      {"field": "mailClass", "allowed_values": ["FCM", "First-Class Mail"]},
      {"field": "productWeight", "max": 13, "unit": "oz"}
    ],
    "USPS Marketing Mail": [
      {"field": "mailClass", "allowed_values": ["STD", "Marketing Mail"]},
      {"field": "quantity", "min": 200, "unit": "pieces"}
    ]
  },
  "processing_category_rules": {
    "Cards": [
      {"field": "productHeight", "max": 4.25},
      {"field": "productLength", "max": 6},
      {"field": "productThickness", "max": 0.016},
      {"field": "productWeight", "max": 1, "unit": "oz"}
    ],
    "Letters": [
      {"field": "productHeight", "min": 3.5, "max": 6.125},
      {"field": "productLength", "min": 5, "max": 11.5},
      {"field": "productThickness", "min": 0.007, "max": 0.25},
      {"field": "productWeight", "max": 3.5, "unit": "oz"}
    ],
    "Flats": [
      {"field": "productHeight", "min": 6.125, "max": 12},
      {"field": "productLength", "min": 11.5, "max": 15},
      {"field": "productThickness", "min": 0.009, "max": 0.75},
      {"field": "productWeight", "max": 13, "unit": "oz"}
    ],
    "Parcels": [
      {"field": "productHeight", "max": 108},
      {"field": "productLength", "max": 108},
      {"field": "productWeight", "max": 70, "unit": "lb"},
      {"field": "productThickness", "max": 18}
    ]
  },
  "machinability_rules": {
    "Automation": [
      {"field": "imBarcode", "value": true},
      {"field": "isUniformThickness", "value": true},
      {"field": "isFlexible", "value": true}
    ],
    "Machinable": [
      {"field": "isFlexible", "value": true},
      {"field": "isUniformThickness", "value": true},
      {"field": "imBarcode", "value": false}
    ],
    "Nonmachinable": [
      {"field": "isFlexible", "value": false}
    ],
    "Presorted": [
      {"field": "presortOnly", "value": true}
    ]
  },
   "sortation_combinations": [

    {"match": ["USPS Marketing Mail", "Automation", "Letters"], "sortation": "STD AUTO LETTERS"},

    {"match": ["USPS Marketing Mail", "Nonmachinable", "Letters"], "sortation": "STD NONMACH LETTERS"},

    {"match": ["USPS Marketing Mail", "Presorted", "Flats"], "sortation": "STD PRESORTED FLATS"},

 

    {"match": ["First-Class Mail", "Automation", "Cards"], "sortation": "FCM AUTO CARDS"},

    {"match": ["First-Class Mail", "Automation", "Letters"], "sortation": "FCM AUTO LETTERS"},

    {"match": ["First-Class Mail", "Automation", "Flats"], "sortation": "FCM AUTO FLATS"},

 

    {"match": ["First-Class Mail", "Machinable", "Cards"], "sortation": "FCM MACH CARDS"},

    {"match": ["First-Class Mail", "Machinable", "Letters"], "sortation": "FCM MACH LETTERS"},

    {"match": ["First-Class Mail", "Presorted", "Flats"], "sortation": "FCM PRESORTED FLATS"},

 

    {"match": ["First-Class Mail", "Nonmachinable", "Letters"], "sortation": "FCM NONMACH LETTERS"},

    {"match": ["First-Class Mail", "Nonmachinable", "Cards"], "sortation": "FCM NONMACH CARDS"},

 

    {"match": ["Parcels"], "sortation": "PARCEL - NOT PROCESSIBLE BY OUR SERVICE"},

    {"match": ["Nonmailable"], "sortation": "NONMAILABLE - DOES NOT MEET USPS STANDARDS"}

  ]
};

const getUSPSSortation = (input) => {
  // Defensive check for rules initialization
  if (!rules) {
    console.error('Rules not initialized');
    return {
      error: 'Internal error: Rules not initialized',
      aspectRatio: 'N/A',
      selectedCategory: null,
      sortation: 'Nonmailable',
      note: 'Internal server error'
    };
  }

  console.log('Rules initialized:', !!rules);
  console.log('Input received:', input);

  const { productHeight, productLength, productThickness, productWeight, imBarcode, isUniformThickness, isFlexible, presortOnly, mailClass, quantity } = input;

  // Calculate aspect ratio
  const aspectRatio = productLength && productHeight ? (productLength / productHeight).toFixed(2) : 'N/A';

  // Validate mail class
  let selectedMailClass = null;
  for (const [mailClassName, mailRules] of Object.entries(rules.mail_class_rules)) {
    let valid = true;
    for (const rule of mailRules) {
      if (rule.field === 'mailClass' && !rule.allowed_values.includes(mailClass)) {
        valid = false;
        break;
      }
      if (rule.field === 'productWeight' && rule.unit === 'oz' && productWeight > rule.max) {
        valid = false;
        break;
      }
      if (rule.field === 'quantity' && quantity < rule.min) {
        valid = false;
        break;
      }
    }
    if (valid) {
      selectedMailClass = mailClassName;
      break;
    }
  }

  if (!selectedMailClass) {
    return {
      error: 'Invalid mail class or parameters',
      aspectRatio,
      selectedCategory: null,
      sortation: 'Nonmailable',
      note: 'Fails minimum USPS mailability thresholds or logic'
    };
  }

  // Determine processing category
  let selectedCategory = null;
  for (const [category, categoryRules] of Object.entries(rules.processing_category_rules)) {
    let valid = true;
    for (const rule of categoryRules) {
      const value = {
        productHeight,
        productLength,
        productThickness,
        productWeight
      }[rule.field];

      if (rule.min !== undefined && value < rule.min) {
        valid = false;
        break;
      }
      if (rule.max !== undefined && value > rule.max) {
        valid = false;
        break;
      }
      if (rule.unit === 'lb' && input.weightUnit === 'oz' && productWeight / 16 > rule.max) {
        valid = false;
        break;
      }
      if (rule.unit === 'oz' && input.weightUnit === 'lbs' && productWeight * 16 > rule.max) {
        valid = false;
        break;
      }
    }
    if (valid) {
      selectedCategory = category;
      break;
    }
  }

  if (!selectedCategory) {
    return {
      error: 'Invalid dimensions or weight for any processing category',
      aspectRatio,
      selectedCategory: null,
      sortation: 'Nonmailable',
      note: 'Fails minimum USPS mailability thresholds or logic'
    };
  }

  // Determine machinability
  let machinability = null;
  for (const [machinabilityType, machinabilityRules] of Object.entries(rules.machinability_rules)) {
    let valid = true;
    for (const rule of machinabilityRules) {
      const value = {
        imBarcode,
        isUniformThickness,
        isFlexible,
        presortOnly
      }[rule.field];
      if (value !== rule.value) {
        valid = false;
        break;
      }
    }
    if (valid) {
      machinability = machinabilityType;
      break;
    }
  }

  if (!machinability) {
    machinability = 'Nonmachinable'; // Default to Nonmachinable if no other match
  }

  // Find sortation combination
  let sortationResult = null;
  for (const combination of rules.sortation_combinations) {
    const [mailClassMatch, machinabilityMatch, categoryMatch] = combination.match;
    if (
      (mailClassMatch === '*' || mailClassMatch === selectedMailClass) &&
      (machinabilityMatch === '*' || machinabilityMatch === machinability) &&
      (categoryMatch === '*' || categoryMatch === selectedCategory)
    ) {
      sortationResult = combination;
      break;
    }
  }

  if (!sortationResult) {
    sortationResult = rules.sortation_combinations.find(combo => combo.match[0] === '*' && combo.match[1] === '*' && combo.match[2] === '*');
  }

  return {
    selectedCategory,
    aspectRatio,
    sortation: sortationResult?.sortation,
    note: sortationResult?.note || null,
    error: sortationResult?.sortation === 'Nonmailable' ? sortationResult?.note : null
  };
};

export default getUSPSSortation;